import { createSelector } from 'reselect';

export const getWorkflow = (state) => state.workflow;

export const getDecisionTreeIframeSrc = createSelector(
  getWorkflow,
  (workflow) => workflow?.decisionTreeIframeSrc
);

export const getInspectionMeasurementDataIframeSrc = createSelector(
  getWorkflow,
  (workflow) => workflow?.inspectionMeasurementDataIframeSrc
);

export const getIsWorkflowRequestPending = createSelector(
  getWorkflow,
  (workflow) => workflow?.isWorkflowRequestPending
);
